import type { TFunction } from 'i18next';
import type { U3202ModelCapabilities } from '../../utils/U3202CapabilitiesTypes';
import { u3202FormatCapabilitiesSummary } from '../../utils/u3202FormatCapabilitiesSummary';

interface U3202CapabilitiesBadgesProps {
  capabilities: U3202ModelCapabilities | null | undefined;
  t: TFunction;
  ns: string;
  compact?: boolean;
}

function U3202CapabilitiesBadges({ capabilities, t, ns, compact = false }: U3202CapabilitiesBadgesProps) {
  const badges = u3202FormatCapabilitiesSummary(capabilities, t, ns);

  if (badges.length === 0) {
    return (
      <span className="text-sm text-muted-foreground">{t('capabilities.none', { ns })}</span>
    );
  }

  return (
    <div className={`flex flex-wrap gap-1 ${compact ? '' : 'md:col-span-2'}`}>
      {badges.map((badge) => (
        <span
          key={badge.key}
          title={badge.detail}
          className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700 dark:bg-slate-800 dark:text-slate-200"
        >
          {badge.label}
          {badge.detail && !compact ? (
            <span className="ml-1 text-muted-foreground">({badge.detail})</span>
          ) : null}
        </span>
      ))}
    </div>
  );
}

export default U3202CapabilitiesBadges;
